export default "__VITE_ASSET__8j0LIHF4__"